import { IS_PRODUCTION, IS_QA, IS_STAGING } from './environment';

const URL_DEV = process.env.REACT_APP_API_URL_DEV ||
    'https://chayns-status-page-backend-staging-w2imyyarrq-ey.a.run.app';
const URL_QA = process.env.REACT_APP_API_URL_QA ||
    'https://chayns-status-page-backend-staging-w2imyyarrq-ey.a.run.app';
const URL_STAGING = process.env.REACT_APP_API_URL_STAGING ||
    'https://chayns-status-page-backend-staging-w2imyyarrq-ey.a.run.app';
const URL_PRODUCTION = process.env.REACT_APP_API_URL_PRODUCTION ||
    'https://chayns-status-page-backend-539195584935.europe-west3.run.app';

const BASE_ROUTE = () => {
    switch (true) {
        case IS_PRODUCTION:
            return URL_PRODUCTION;
        case IS_STAGING:
            return URL_STAGING;
        case IS_QA:
            return URL_QA;
        default:
            return URL_DEV;
    }
};

export const BASE_URL = BASE_ROUTE();

export const FORUM = {
    desktop: 'https://chayns.net/forum',
    mobile: 'https://chayns.cc/w42u14',
};

export const TUTORIALS = {
    desktop: 'https://chayns.site/videos',
    mobile: 'https://chayns.cc/ttd56g',
};

export const WORKSHOPS = {
    desktop: 'https://labs.tobit.com/termine',
    mobile: 'https://chayns.cc/njszmq',
};

export const SUPPORT_HOTLINE = '02561 913 123';
export const SUPPORT_HOTLINE_TEL = '+492561913123';
